import React from "react";
import { Navigate } from "react-router-dom";

// Dashboard
import AdminDashboard from "../pages/AdminDashboard";

// pages
import Category from "../pages/Category";
import Registered from "../pages/Registered";
import BlogEditor from "../pages/Blog";
import BannerManagement from "../pages/Banner";
import Product from "../pages/Product";
import Contact from "../pages/Contact";
import Newsletter from "../pages/Newsletter";
import Order from "../pages/Order";
import Testimonial from "../pages/Testimonial";
import MarketingLinks from "../pages/Marketing/MarketingLinks";
import ReferralDiscounts from "../pages/Marketing/ReferralDiscounts";
import Offers from "../pages/Marketing/Offers";
import AffiliateUsers from "../pages/Marketing/AffiliateUsers";
import AffiliateCommissions from "../pages/Marketing/AffiliateCommissions";
import AffiliatePayoutHistory from "../pages/Marketing/AffiliatePayoutHistory";
import RecordAffiliatePayout from "../pages/Marketing/RecordAffiliatePayout";
import AffiliateWithdrawals from "../pages/Marketing/AffiliateWithdrawals";
import PaymentHistory from "../pages/Payment/PaymentHistory";
import SpotlightManagement from "../pages/Spotlight";
import WhatsAppInbox from "../pages/WhatsAppInbox";
import Invoices from "../pages/Invoices";
import Reviews from "../pages/Reviews";
import SkinAssistantRules from "../pages/SkinAssistant/RulesEditor";
import SkinAssistantResults from "../pages/SkinAssistant/ResultsDashboard";
import SkinAssistantLeads from "../pages/SkinAssistant/LeadsList";
import SkinAssistantChats from "../pages/SkinAssistant/ChatsList";

const protectedRoutes = [
  { path: "/", element: <Navigate to="/admin/dashboard" replace /> },
  { path: "/admin/dashboard", element: <AdminDashboard /> },
  { path: "/category", element: <Category /> },
  { path: "/registered", element: <Registered /> },
  { path: "/blog-editor", element: <BlogEditor /> },
  { path: "/product", element: <Product /> },
  { path: "/banner", element: <BannerManagement /> },
  { path: "/contact", element: <Contact /> },
  { path: "/whatsapp-inbox", element: <WhatsAppInbox /> },
  { path: "/newsletter", element: <Newsletter /> },
  { path: "/order", element: <Order /> },
  { path: "/invoices", element: <Invoices /> },
  { path: "/testimonial", element: <Testimonial /> },
  { path: "/marketing-links", element: <MarketingLinks /> },
  { path: "/referral-discounts", element: <ReferralDiscounts /> },
  { path: "/offers", element: <Offers /> },
  { path: "/affiliate-users", element: <AffiliateUsers /> },
  { path: "/affiliate-commissions", element: <AffiliateCommissions /> },
  { path: "/affiliate-withdrawals", element: <AffiliateWithdrawals /> },
  { path: "/affiliate-payouts", element: <AffiliatePayoutHistory /> },
  { path: "/affiliate-payouts/new", element: <RecordAffiliatePayout /> },
  { path: "/payment-history", element: <PaymentHistory /> },
  { path: "/spotlight", element: <SpotlightManagement /> },
  { path: "/reviews", element: <Reviews /> },
  { path: "/skin-assistant/rules", element: <SkinAssistantRules /> },
  { path: "/skin-assistant/results", element: <SkinAssistantResults /> },
  { path: "/skin-assistant/leads", element: <SkinAssistantLeads /> },
  { path: "/skin-assistant/chats", element: <SkinAssistantChats /> },
];

export default protectedRoutes;